import React from "react";

const getYouTubeEmbedUrl = (videoSrc) => {
  const videoIdMatch = videoSrc.match(/(?:youtu\.be\/|v=)([^&?/]+)/);
  return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : "";
};

const YoutubeVideoModal = ({ videoSrc, isOpen, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg overflow-hidden shadow-lg max-w-6xl w-full relative">
        <div className="flex justify-between p-4">
          <h2 className="font-medium">Watch Video</h2>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onCancel}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-4">
          <iframe
            src={getYouTubeEmbedUrl(videoSrc)}
            title="Video"
            className="w-full aspect-video rounded-md block"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default YoutubeVideoModal;
